// extracted by css-extract-rspack-plugin
var _1 = "button__T9dum";
var _2 = "container__F33r6";
var _3 = "text__FY61q";
export { _1 as "button", _2 as "container", _3 as "text" }
export default { "button": _1, "container": _2, "text": _3 }
